import type { Card } from "./Card";

export class GroupedCards {
    cards: Card[];
    totalCards?: number;
    total?: number;
    groupKey?: string;
    groupName?: string;
    totalLoaded?: number;
    totalSelected?: number;
    hidden?: boolean;
    index?: number;
    allSelected?: boolean;
}
